import _defineProperty from "@babel/runtime/helpers/defineProperty";
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../../../common/constants/proptypes/CommonPropTypes";
import AddonDiscoveryPropTypes from "../../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import FacetContent from "../../../common/FacetContent"; // eslint-disable-next-line import/no-named-as-default

import ConjunctiveFacetDropdown from "./ConjunctiveFacetDropdown";
import DisjunctiveFacetDropdown from "./DisjunctiveFacetDropdown";
export default class FacetDropdown extends Component {
  render() {
    return /*#__PURE__*/React.createElement(FacetContent, {
      facetBar: this.props.facetBar,
      facetType: this.props.facetType,
      filters: this.props.filters,
      items: this.props.items,
      label: this.props.label,
      onItemActivated: this.props.onItemActivated,
      ConjunctiveFacet: ConjunctiveFacetDropdown,
      DisjunctiveFacet: DisjunctiveFacetDropdown,
      perspective: this.props.perspective,
      stateChangeRequested: this.props.stateChangeRequested
    });
  }

}

_defineProperty(FacetDropdown, "propTypes", {
  facetBar: PropTypes.oneOf(['top', 'side']),
  facetType: AddonDiscoveryPropTypes.facetType.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  items: PropTypes.oneOfType([ImmutablePropTypes.list, PropTypes.object]).isRequired,
  label: PropTypes.string.isRequired,
  onItemActivated: PropTypes.func.isRequired,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
});